export default "__VITE_PUBLIC_ASSET__42480b4f__"